import { render, staticRenderFns } from "./SelectPayment.vue?vue&type=template&id=4b78e972&scoped=true&"
import script from "./SelectPayment.vue?vue&type=script&lang=js&"
export * from "./SelectPayment.vue?vue&type=script&lang=js&"
import style0 from "./SelectPayment.vue?vue&type=style&index=0&id=4b78e972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b78e972",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b78e972')) {
      api.createRecord('4b78e972', component.options)
    } else {
      api.reload('4b78e972', component.options)
    }
    module.hot.accept("./SelectPayment.vue?vue&type=template&id=4b78e972&scoped=true&", function () {
      api.rerender('4b78e972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopInfo/components/TopUpPackage/components/SelectPayment.vue"
export default component.exports